// TODO: переместить buttons в form, объединить enum-ы

export enum EButtonSize {
  XS32 = 'xs32',
  S36 = 's36',
  M40 = 'm40',
  L48 = 'l48',
  XL56 = 'xl56',
}
